import { SVGProps } from 'react';

export default function GroupsIcon({
  height = '24px',
  width = '24px',
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 49.32 41.04'
      {...props}
    >
      <path d='M48.15,2.95c-.88-.56-2.03-.51-2.86,.12-.35,.26-8.64,6.37-19.33,.36C16.3-1.99,8.44,.19,4.52,2.05c-.65-.87-1.81-1.27-2.88-.87C.34,1.66-.32,3.1,.16,4.4L13.07,39.4c.37,1.01,1.33,1.64,2.35,1.64,.29,0,.58-.05,.87-.16,1.3-.48,1.96-1.92,1.48-3.22l-5.21-14.12c.71-.65,3.74-2.58,14.64-2.51,.09,0,.18,0,.27,0,18.25,0,21.75-15.3,21.78-15.45,.22-1.02-.23-2.07-1.11-2.64Zm-20.67,13.08c-.08,0-.15,0-.23,0-8.62-.05-13.49,1.1-16.25,2.54L6.44,6.68c2.8-1.39,9.09-3.36,17.07,1.12,7.04,3.96,13.31,3.72,17.79,2.52-2.42,2.86-6.64,5.7-13.81,5.7Z' />
    </svg>
  );
}
